<template>
  <div id="EnergyIndex">
    <div class="top">能源管理概览</div>
    <div class="centent clearfix">
      <!-- 用电统计 -->
      <div class="f-l w-335">
        <div class="box1">
          <div class="title"><img src="@/assets/image/energy/icon1.png">用电统计</div>
          <div class="data-box">
            <div>
              <div class="f-l img-box">
                <img src="@/assets/image/energy/icon5.png">
              </div>
              <div class="f-l details">
                <p class="details-title"> 总用电量</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(Report.total)">{{Report.total==null?"--":bigNumberTransform(Report.total,5)}}<span class="num-unit">{{getUnit(Report.total,5)}}</span><span v-show="Report.total!=null"> kW·h</span></p>
              </div>
            </div>
            <div>
              <div class="f-l img-box m-l-0">
                <img src="@/assets/image/energy/icon6.png">
              </div>
              <div class="f-l details">
                <p class="details-title"> 年用电量</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(Report.lastYear)">{{Report.lastYear==null?"--":bigNumberTransform(Report.lastYear,5)}}<span class="num-unit">{{getUnit(Report.lastYear,5)}}</span><span v-show="Report.lastYear!=null"> kW·h</span></p>
                <p class="ratio" v-if="Report.lastYearRatio==0||Report.lastYearRatio">环比 <img
                    src="@/assets/image/energy/on.png" v-if="Report.lastYearRatio>0"><img
                    src="@/assets/image/energy/down.png" v-if="!Report.lastYearRatio>0"> <span
                    :style="{color:Report.lastYearRatio>0?'#FF3333':'#00CC33'}">{{floatMultiply(Report.lastYearRatio,1).toFixed(2)}}%</span>
                </p>
              </div>
            </div>
            <div>
              <div class="f-l img-box">
                <img src="@/assets/image/energy/icon7.png">
              </div>
              <div class="f-l details">
                <p class="details-title"> 月用电量</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(Report.lastMonth)">{{Report.lastMonth==null?"--":bigNumberTransform(Report.lastMonth,5)}}<span  class="num-unit">{{getUnit(Report.lastMonth,5)}}</span><span v-show="Report.lastMonth!=null"> kW·h</span></p>
                <p class="ratio" v-if="Report.lastMonthRatio==0||Report.lastMonthRatio">环比 <img
                    src="@/assets/image/energy/on.png" v-if="Report.lastMonthRatio>0"><img
                    src="@/assets/image/energy/down.png" v-if="!Report.lastMonthRatio>0"> <span
                    :style="{color:Report.lastMonthRatio>0?'#FF3333':'#00CC33'}">{{floatMultiply(Report.lastMonthRatio,1).toFixed(2)}}%</span>
                </p>
              </div>
            </div>
            <div>
              <div class="f-l img-box m-l-0">
                <img src="@/assets/image/energy/icon8.png">
              </div>
              <div class="f-l details">
                <p class="details-title"> 日用电量</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(Report.yesterday)">{{Report.yesterday==null?"--":bigNumberTransform(Report.yesterday,5)}}<span class="num-unit">{{getUnit(Report.yesterday,5)}}</span><span v-show="Report.yesterday!=null"> kW·h</span></p>
                <p class="ratio" v-if="Report.yesterdayRatio==0||Report.yesterdayRatio">环比 <img
                    src="@/assets/image/energy/on.png" v-if="Report.yesterdayRatio>0"><img
                    src="@/assets/image/energy/down.png" v-if="!Report.yesterdayRatio>0"> <span
                    :style="{color:Report.yesterdayRatio>0?'#FF3333':'#00CC33'}">{{floatMultiply(Report.yesterdayRatio,1).toFixed(2)}}%</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 能耗对标 -->
        <div class="box2">
          <div class="title"><img src="@/assets/image/energy/icon2.png">能耗对标</div>
          <div class="m-t-10">
            <div class="clearfix">
              <div class="img-box2 f-l">
                <img src="@/assets/image/energy/icon13.png">
              </div>
              <div class="right-data f-l">
                <p class="data-title">本月用电定额: <span v-if="config.monthElectricityQuota&&config.monthElectricityQuota!=''" :title="common.fmoney(config.monthElectricityQuota)">{{bigNumberTransform(config.monthElectricityQuota,5)}}{{getUnit(config.monthElectricityQuota,5)}} kW·h</span></p>
                <progress-bar :value="getPercentage(config.monthElectricityQuota,Report.currentMonth)" :type="getType(config.monthElectricityQuota,Report.currentMonth)"></progress-bar>
                <div class="clearfix exceed">
                  <p class="f-l">已使用:
                  <span class="blue2" :class="{'yellow':getType(config.monthElectricityQuota,Report.currentMonth)==2}" :title="common.fmoney(Report.currentMonth)">{{Report.currentMonth==null?'--':bigNumberTransform(Report.currentMonth,5) }} </span>
                  <span class="blue2 num-unit" :class="{'yellow':getType(config.monthElectricityQuota,Report.currentMonth)==2}">{{getUnit(Report.currentMonth,5)}}</span>
                  <span class="unit2" :class="{'unit':getType(config.monthElectricityQuota,Report.currentMonth)==2}" v-show="Report.currentMonth!=null">kW·h</span>
                  </p>
                  <p class="f-r t-hide" style="margin-top: 4px;margin-right: 14px;max-width: 41%;">超出: <span
                      class="blue" :title="common.fmoney(getExceed(Report.currentMonth,config.monthElectricityQuota))">{{ bigNumberTransform(getExceed(Report.currentMonth,config.monthElectricityQuota),5) }} {{getUnit(getExceed(Report.currentMonth,config.monthElectricityQuota),5)}}kW·h</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="m-t-10" v-if="config.other&&config.other.water&&config.other.water.length==2">
            <div class="clearfix">
              <div class="img-box2 f-l">
                <img src="@/assets/image/energy/icon14.png">
              </div>
              <div class="right-data f-l">
                <p class="data-title">本月用水定额: <span v-if="config.monthWaterQuota&&config.monthWaterQuota!=''" :title="common.fmoney(config.monthWaterQuota)">{{bigNumberTransform(config.monthWaterQuota,5) }}{{getUnit(config.monthWaterQuota,5)}} m3</span></p>
                <progress-bar :value="getPercentage(config.monthWaterQuota,deviceValue.water)" :type="getType(config.monthWaterQuota,deviceValue.water)"></progress-bar>
                <div class="clearfix exceed">
                  <p class="f-l">已使用:
                  <span class="blue2" :class="{'yellow':getType(config.monthWaterQuota,deviceValue.water)==2}" :title="common.fmoney(deviceValue.water)">{{deviceValue.water==null?'--':bigNumberTransform(deviceValue.water,5)}} </span>
                  <span class="blue2 num-unit" :class="{'yellow':getType(config.monthWaterQuota,deviceValue.water)==2}">{{getUnit(deviceValue.water,5)}}</span>
                  <span class="unit2" :class="{'unit':getType(config.monthWaterQuota,deviceValue.water)==2}" v-show="deviceValue.water!=null">m3</span></p>
                  <p class="f-r t-hide" style="margin-top: 4px;margin-right: 14px;max-width: 40%;">超出: <span
                      class="blue" :title="common.fmoney(getExceed(deviceValue.water,config.monthWaterQuota))">{{bigNumberTransform(getExceed(deviceValue.water,config.monthWaterQuota),5)}} {{getUnit(getExceed(deviceValue.water,config.monthWaterQuota),5)}}m3</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="m-t-10" v-if="config.other&&config.other.gas&&config.other.gas.length==2">
            <div class="clearfix">
              <div class="img-box2 f-l">
                <img src="@/assets/image/energy/icon15.png">
              </div>
              <div class="right-data f-l">
                <p class="data-title">本月用气定额: <span v-if="config.monthGasQuota&&config.monthGasQuota!=''" :title="common.fmoney(config.monthGasQuota)">{{bigNumberTransform(config.monthGasQuota,5)}}{{getUnit(config.monthGasQuota,5)}} m3</span></p>
                <progress-bar :value="getPercentage(config.monthGasQuota,deviceValue.gas)" :type="getType(config.monthGasQuota,deviceValue.gas)"></progress-bar>
                <div class="clearfix exceed">
                  <p class="f-l">已使用:
                  <span class="blue2" :class="{'yellow':getType(config.monthGasQuota,deviceValue.gas)==2}" :title="common.fmoney(deviceValue.gas)">{{deviceValue.gas==null?'--':bigNumberTransform(deviceValue.gas,5)}} </span>
                  <span class="blue2 num-unit" :class="{'yellow':getType(config.monthGasQuota,deviceValue.gas)==2}">{{getUnit(deviceValue.gas,5)}}</span>
                  <span class="unit2" :class="{'unit':getType(config.monthGasQuota,deviceValue.gas)==2}" v-show="deviceValue.gas!=null">m3</span></p>
                  <p class="f-r t-hide" style="margin-top: 4px;margin-right: 14px;max-width: 40%;">超出: <span
                      class="blue" :title="common.fmoney(getExceed(deviceValue.gas,config.monthGasQuota))">{{bigNumberTransform(getExceed(deviceValue.gas,config.monthGasQuota),5)}} {{getUnit(getExceed(deviceValue.gas,config.monthGasQuota),5)}}m3</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="m-t-10" v-if="config.other&&config.other.thermal&&config.other.thermal.length==2">
            <div class="clearfix">
              <div class="img-box2 f-l">
                <img src="@/assets/image/energy/icon16.png">
              </div>
              <div class="right-data f-l">
                <p class="data-title">本月用热定额: <span v-if="config.monthThermalQuota&&config.monthThermalQuota!=''" :title="common.fmoney(config.monthThermalQuota)">{{bigNumberTransform(config.monthThermalQuota,5)}}{{getUnit(config.monthThermalQuota,5)}} GJ</span></p>
                <progress-bar :value="getPercentage(config.monthThermalQuota,deviceValue.thermal)" :type="getType(config.monthThermalQuota,deviceValue.thermal)"></progress-bar>
                <div class="clearfix exceed">
                  <p class="f-l">已使用:
                  <span class="blue2" :class="{'yellow':getType(config.monthThermalQuota,deviceValue.thermal)==2}" :title="common.fmoney(deviceValue.thermal)">{{deviceValue.thermal==null?'--':bigNumberTransform(deviceValue.thermal,5)}} </span>
                  <span class="blue2 num-unit" :class="{'yellow':getType(config.monthThermalQuota,deviceValue.thermal)==2}">{{getUnit(deviceValue.thermal,5)}}</span>
                  <span class="unit2" :class="{'unit':getType(config.monthThermalQuota,deviceValue.thermal)==2}" v-show="deviceValue.thermal!=null">GJ</span>
                  </p>
                  <p class="f-r t-hide" style="margin-top: 4px;margin-right: 14px;max-width: 38%;">超出: <span
                      class="blue" :title="common.fmoney(getExceed(deviceValue.thermal,config.monthThermalQuota))">{{bigNumberTransform(getExceed(deviceValue.thermal,config.monthThermalQuota),5)}} {{getUnit(getExceed(deviceValue.thermal,config.monthThermalQuota),5)}}GJ</span></p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- 本月能源指标 -->
      <div class="f-l w-910 m-l-20 bg2">
        <div class="box3">
          <p class="score">{{Score.score ? parseInt(Score.score) : '--'}}<span>分</span></p>
          <div class="item-box clearfix" style="left: 173.4px; top: 48px;">
            <div class="img-box3 f-l"><img src="@/assets/image/energy/icon17.png"></div>
            <div class="lab-box f-l">
              <div>能源成本</div>
              <p class="t-hide"><span class="lab-value" :title="common.fmoney(Cost.cost)">{{Cost.cost==null?'--':bigNumberTransform(Cost.cost,5)}}</span><span class="num-unit">{{getUnit(Cost.cost,5)}} </span><span class="lab-unit" v-show="Cost.cost!=null">元</span></p>
            </div>
          </div>
          <div class="item-box" style="left: 583.4px; top: 28px;">
            <div class="img-box3 f-l"><img src="@/assets/image/energy/icon18.png"></div>
            <div class="lab-box f-l">
              <div>存续报警</div>
              <p class="t-hide"><span class="lab-value">{{hold[0].num}}</span></p>
            </div>
          </div>
          <div class="item-box" style="left: 17.4px; top: 204.4px;">
            <div class="img-box3 f-l"><img src="@/assets/image/energy/icon19.png"></div>
            <div class="lab-box f-l">
              <div>定额超量成本</div>
              <p class="t-hide"><span class="lab-value" :title="common.fmoney(Cost.aboveCost)">{{Cost.aboveCost==null?'--':bigNumberTransform(Cost.aboveCost,5)}}</span><span class="num-unit">{{getUnit(Cost.aboveCost,5)}} </span><span class="lab-unit" v-show="Cost.aboveCost!=null">元</span></p>
            </div>
          </div>
          <div class="item-box" style="left: 657.4px; top: 196.4px;">
            <div class="img-box3 f-l"><img src="@/assets/image/energy/icon20.png"></div>
            <div class="lab-box f-l">
              <div>未确认报警</div>
              <p class="t-hide"><span class="lab-value">{{hold[1].num}}</span></p>
            </div>
          </div>
          <div class="item-box" style="left: 83.4px; top: 382.4px;">
            <div class="img-box3 f-l"><img src="@/assets/image/energy/icon21.png"></div>
            <div class="lab-box f-l">
              <div>CO₂排放量</div>
              <p class="t-hide"><span class="lab-value" :title="common.fmoney(Cost.co2)">{{Cost.co2==null?'--':bigNumberTransform(parseInt(Cost.co2),5)}}</span><span class="num-unit">{{getUnit(Cost.co2,5)}} </span><span class="lab-unit" v-show="Cost.co2!=null">吨</span></p>
            </div>
          </div>
          <div class="item-box" style="left: 489.4px; top: 368.4px;">
            <div class="img-box3 f-l"><img src="@/assets/image/energy/icon22.png"></div>
            <div class="lab-box f-l">
              <div>8小时内新增</div>
              <p class="t-hide"><span class="lab-value">{{hold[2].num}}</span></p>
            </div>
          </div>
        </div>
      </div>
      <!-- 用气统计 -->
      <div class="f-l w-335 m-l-20">
        <div class="box1">
          <div class="title"><img src="@/assets/image/energy/icon26.png">统计</div>
          <div class="data-box">
            <div>
              <div class="f-l img-box">
                <img src="@/assets/image/energy/icon27.png">
              </div>
              <div class="f-l details attr">
                <p class="details-title"> {{config.other&&config.other.gasTotal&&config.other.gasTotal.length==2?deviceValue.gasTotalName:'--'}}</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(deviceValue.gasTotal)">{{deviceValue.gasTotal==null?'--':bigNumberTransform(deviceValue.gasTotal,5)}}<span class="num-unit">{{getUnit(deviceValue.gasTotal,5)}}</span><span v-show="deviceValue.gasTotal!=null"> {{deviceValue.gasTotalUnit}}</span></p>
                <!-- <p class="ratio">环比 <img src="@/assets/image/energy/down.png"> <span :style="{color:'#00CC33'}">{{'--'}}%</span></p> -->
                </p>
              </div>
            </div>
            <div>
              <div class="f-l img-box m-l-0">
                <img src="@/assets/image/energy/icon27.png">
              </div>
              <div class="f-l details attr">
                <p class="details-title"> {{config.other&&config.other.gasYear&&config.other.gasYear.length==2?deviceValue.gasYearName:'--'}}</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(deviceValue.gasYear)">{{deviceValue.gasYear==null?'--':bigNumberTransform(deviceValue.gasYear,5)}}<span class="num-unit">{{getUnit(deviceValue.gasYear,5)}}</span><span v-show="deviceValue.gasYear!=null"> {{deviceValue.gasYearUnit}}</span></p>
                <!-- <p class="ratio">环比 <img src="@/assets/image/energy/down.png"> <span :style="{color:'#00CC33'}">{{'--'}}%</span></p> -->
              </div>
            </div>
            <div>
              <div class="f-l img-box">
                <img src="@/assets/image/energy/icon27.png">
              </div>
              <div class="f-l details attr">
                <p class="details-title"> {{config.other&&config.other.gasMonth&&config.other.gasMonth.length==2?deviceValue.gasMonthName:'--'}}</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(deviceValue.gasMonth)">{{deviceValue.gasMonth==null?'--':bigNumberTransform(deviceValue.gasMonth,5)}}<span class="num-unit">{{getUnit(deviceValue.gasMonth,5)}}</span><span v-show="deviceValue.gasMonth!=null"> {{deviceValue.gasMonthUnit}}</span></p>
                <!-- <p class="ratio">环比 <img src="@/assets/image/energy/down.png"> <span :style="{color:'#00CC33'}">{{'--'}}%</span></p> -->
              </div>
            </div>
            <div>
              <div class="f-l img-box m-l-0">
                <img src="@/assets/image/energy/icon27.png">
              </div>
              <div class="f-l details attr">
                <p class="details-title"> {{config.other&&config.other.gasDay&&config.other.gasDay.length==2?deviceValue.gasDayName:'--'}}</p>
                <p style="padding-left: 5px;line-height: 18px;" :title="common.fmoney(deviceValue.gasDay)">{{deviceValue.gasDay==null?'--':bigNumberTransform(deviceValue.gasDay,5)}}<span class="num-unit">{{getUnit(deviceValue.gasDay,5)}}</span><span v-show="deviceValue.gasDay!=null"> {{deviceValue.gasDayUnit}}</span></p>
                <!-- <p class="ratio">环比 <img src="@/assets/image/energy/down.png"> <span :style="{color:'#00CC33'}">{{'--'}}%</span></p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="box2">
          <div class="title"><img src="@/assets/image/energy/icon4.png">最新报警</div>
          <div class="warn-title">
            <li class="w-30">报警名</li>
            <li class="w-20">设备</li>
            <li class="w-30">时间</li>
            <li class="w-20">状态</li>
          </div>
          <div class="warn-box">
            <div class="warn-lab" v-for="(item,i) in warnList" :key="i">
              <li class="w-30 t-hide" :title="item.name">{{item.name}}</li>
              <li class="w-20 t-hide" :title="getDeviceName(item.deviceId)">{{getDeviceName(item.deviceId)}}</li>
              <li class="w-30 t-hide">{{changeDate(item.updatedTime)}}</li>
              <li class="w-20 t-hide">{{item.state==1?'已恢复':item.state==2?'存续':'手动恢复'}}</li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom clearfix">
      <div class="f-l w-335">
        <div class="box1 p-r">
          <div class="title"><img src="@/assets/image/energy/icon23.png">小时能耗</div>
          <div class="legend">
            <span class="hosr" v-show="hosrArr.length"><span></span>今日</span>
            <span class="day" v-show="dayArr.length"><span></span>昨日</span>
          </div>
          <div id="bar" ref="bar"></div>
          <div class="notData" v-show="showBar">暂无数据</div>
        </div>

      </div>
      <div class="f-l w-910 m-l-20">
        <div class="box1 nobg p-r">
          <div class="title"><img src="@/assets/image/energy/icon28.png">今日负荷</div>
          <div id="line" ref="line"></div>
          <p class="today"><span></span>今日</p>
          <div class="notData" v-show="!Load.length">暂无数据</div>
        </div>
      </div>
      <div class="f-l w-335 m-l-20">
        <div class="box1">
          <div class="title"><img src="@/assets/image/energy/icon24.png">系统健康指标</div>
          <div class="bg-box">
            <div id="radar" ref="radar"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProgressBar from "./ProgressBar.vue"
  export default {
    data() {
      return {
        config: {other:{gasTotal:[],gasYear:[],gasMonth:[],gasDay:[]}},
        Report: {},
        Cost: {},
        Score: {},
        Load: [],
        mqttClient: null,
        hold: [{}, {}, {}],
        subscribeArr: [],
        warnList: [],
        deviceList: [],
        noGet: false,
        radarChart: null,
        barChart: null,
        lineChart: null,
        deviceValue: {},
        hosrArr: [],
        dayArr: [],
        VirtualDevice:{},
        VirtualDeviceValue:[],
        deviceAttrArr:[],
        showBar:true
      }
    },
    created() {
      this.$store.state.headerActive = 0
      this.$store.state.energyIndex = '/Energy/index'
      this.$forceUpdate()
      this.getVirtualDevice()
    },
    mounted() {
      let t = this
      window.onresize = () => {
        this.resizeChart()
      }
      window.devicePixelRatio = () => {
        this.resizeChart()
      }
    },
    computed: {
      companyId() {
        return this.$store.state.companyId
      },
      companyCode() {
        return this.$store.state.companyCode
      },
      //获取百分比
      getPercentage(){
        return (n1,n2)=>{
          if(!n1&&n1!=0||!n2&&n2!=0){return 0}
          if(n2 < n1){
            return n2/n1 * 100
          }else{
            return 100
          }
        }
      },
      getUnit(){
        return (value,length)=>{
          if(value==0||!value){ return ''}
          // intLenght => 整数长度
          // value => 需要处理的数值
          // length => 最后显示的数值
            if(value!=0&&!value){ return value}

            var intLenght,param = {},k = 10000,sizes = ['', '万', '亿', '万亿'],i,f='';
                value = Math.abs(value)

                if(value%1 == 0){
                  intLenght = value.toString().length
                }else{
                  let arr = value.toString().split('.')
                  intLenght = arr[0].length
                }
                if(intLenght <= length){
                  value = value.toFixed(length-intLenght);
                  if(value%1 == 0){
                    value = parseInt(value)
                  }
                  return ''
                }

                if(value*10 < k){
                    param.value = value.toFixed(2)
                    param.unit=''
                }else{
                    i = Math.floor(Math.log(value) / Math.log(k));
                    param.value = (value / Math.pow(k, i));
                    param.unit = sizes[i];
                }
              return param.unit;
        }
      },
      getType(){
        return (max,v)=>{
          if(max==null||v==null){
            return 1
          }else if(max>v){
            return 1
          }else if(max<v){
            return 2
          }
        }
      },
      getExceed() {
        return (a, b) => {
          if (a && b) {
            if (a > b) {
              return a - b
            } else {
              return 0
            }
          } else {
            return 0
          }
        }
      },
      getDeviceName() {
        return (id) => {
          let device = this.deviceList.filter(item => item.id == id)
          if (device[0]) {
            return device[0].name
          } else {
            return "--"
          }
        }
      },
      getAttrName(){
        return (arr,key)=>{
          if(arr.length!=2){return ''}
          let code = arr[0],attr = arr[1],device=this.deviceAttrArr.filter(i => i.code == code)[0]
          if(device){
            let a = device.attrlist.filter(i => i.code == attr)[0]
            if(a){
              return a.name
            }
          }else{
            if(code.substring(0,2)=='_V'&&this.VirtualDevice.id&&this.VirtualDevice.id!=0){
              let data = {
                companyId:this.companyId,
                deviceId:this.VirtualDevice.id
              }
              this.get('/VirtualDevice/getPropertyList',data).then((res)=>{
                if(res.success){
                  let obj = {code:code,attrlist:res.result}
                  this.deviceAttrArr.push(obj)
                  let a = res.result.filter(i => i.code == attr)[0]
                  if(a){
                    this.deviceValue[key] = a.unit?a.unit:''
                    return a.name
                  }else{
                    return '--'
                  }
                }else{
                  this.$message({
                    type: 'warning',
                    message: `获取属性名称失败：${res.message}`
                  })
                  return '--'
                }
              })
            }else{
              let data={
                code:code
              }
              this.get('/ProductFeature/getByDeviceCode',data).then(res=>{
                if(res.success){
                  let arr = [];
                  let tsl;
                  if(res.result==''){
                      tsl={properties:[]}
                  }else{
                      tsl = JSON.parse(res.result)
                  }
                  let obj = {code:code,attrlist:tsl.properties}
                  tsl.properties.map((item)=>{
                    item.code = item.identifier
                  })
                  this.deviceAttrArr.push(obj)
                  let a = tsl.properties.filter(i => i.identifier == attr)[0]
                  if(a){
                    this.deviceValue[key+'Unit'] = a.dataType.specs?a.dataType.specs.unit:''
                    return a.name
                  }else{
                    return '--'
                  }
                }else{
                  this.$message({
                    type: 'warning',
                    message: `获取属性名称失败：${res.message}`
                  })
                  return '--'
                }
              })
            }
          }
        }
      },
      /**
       * 将科学计数法的数字转为字符串
       * 说明：运算精度丢失方法中处理数字的时候，如果出现科学计数法，就会导致结果出错
       * 4.496794759834739e-9  ==> 0.000000004496794759834739
       * 4.496794759834739e+9  ==> 4496794759.834739
       * @param  num
       */
      toNonExponential() {
        return (num) => {
          if (num == null) {
            return num;
          }
          if (typeof num == "number") {
            var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
            return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
          } else {
            return num;
          }
        }
      },

      /**
       * 乘法 - js运算精度丢失问题
       * @param arg1  数1
       * @param arg2  数2
       * 0.0023 * 100 ==> 0.22999999999999998
       * {{ 0.0023 | multiply(100) }} ==> 0.23
       */
      floatMultiply() {
        return (arg1, arg2) => {
          arg1 = Number(arg1);
          arg2 = Number(arg2);
          if ((!arg1 && arg1 !== 0) || (!arg2 && arg2 !== 0)) {
            return null;
          }
          arg1 = this.toNonExponential(arg1);
          arg2 = this.toNonExponential(arg2);
          var n1, n2;
          var r1, r2; // 小数位数
          try {
            r1 = arg1.toString().split(".")[1].length;
          } catch (e) {
            r1 = 0;
          }
          try {
            r2 = arg2.toString().split(".")[1].length;
          } catch (e) {
            r2 = 0;
          }
          n1 = Number(arg1.toString().replace(".", ""));
          n2 = Number(arg2.toString().replace(".", ""));
          return n1 * n2 / Math.pow(10, r1 + r2);
        }
      },
    },
    components: {
      ProgressBar
    },
    methods: {
      // 获取虚拟设备
      getVirtualDevice(){
        this.get('/VirtualDevice/get',{companyId:this.companyId}).then(res=>{
          if(res.success){
            this.VirtualDevice = res.result
          }else{
            this.$message({
              type: 'warning',
              message: `获取虚拟设备失败：${res.message}`
            })
          }
          // 获取配置
          this.getConfig()
        })
      },
      // 雷达图
      setRadar() {
        let value = [this.Score.currentImbalance, this.Score.voltageImbalance, this.Score.totalPowerFactor, this.Score
          .frequencyDeviation, this.Score.currentMonthDeviation
        ]

        var option = {
          radar: [{
            indicator: [{
                text: '三相电流不平衡',
                max: 100
              },
              {
                text: '三相电压差',
                max: 100
              },
              {
                text: '功率因素',
                max: 100
              },
              {
                text: '频率偏差',
                max: 100
              },
              {
                text: '额定功率',
                max: 100
              }
            ],
            center: ['50%', '55%'],
            splitNumber: 3,
            name: {
              formatter: '{value}',
              textStyle: {
                fontSize: 14,
                color: '#CCFFFF' // 文字颜色
              }
            },
            itemStyle: {
              color: '#25AFEF'
            },
            areaStyle: {
              color: 'rgba(37, 175, 239, 0.9)'
            },
            axisLabel: {
              // 坐标轴文本标签，详见axis.axisLabel
              show: false,
              textStyle: {
                color: '#CCFFFF' // 坐标轴刻度文字的样式
              }
            },
            axisLine: { // (圆内的几条直线)坐标轴轴线相关设置
              lineStyle: {
                color: '#1B4C5E',
                // 坐标轴线线的颜色。
                width: 1,
                // 坐标轴线线宽。
                type: 'solid',
                // 坐标轴线线的类型。
              }
            },
            splitLine:{
              lineStyle: {
                color: '#1B4C5E',
                // 坐标轴线线的颜色。
                width: 1,
                // 坐标轴线线宽。
                type: 'solid',
                // 坐标轴线线的类型。
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ['transparent', '#1F344F'] // 图表背景网格的颜色
              }
            }
          }],
          series: [{
            name: '雷达图',
            type: 'radar',
            lineStyle: {
              color: '#25AFEF',
              type: 'dashed',
              width: 1,
            },
            itemStyle: {
              color: '#25AFEF',
            },
            data: [{
              value: value,
              areaStyle: {
                normal: {
                  color: 'rgba(37, 175, 239, 0.9)' // 选择区域颜色
                }
              }
            }]
          }]
        };
        let dom = this.$refs.radar
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("radar"))
        if (Dom == null) {
          this.radarChart = this.$echarts.init(dom, '', {
            width: 335, //设置宽高
            height: 188
          })
        }
        this.radarChart.setOption(option, true)
      },
      // 获取存续数据
      getHold() {
        this.get('/DeviceAlarm/countCompanyAlarmByType', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.hold = res.result
            this.getWarn()
          } else {
            this.$message({
              type: 'warning',
              message: `获取存续数据失败：${res.message}`
            })
          }
          this.$forceUpdate()
        })
      },
      getWarn() {
        if (this.noGet) {
          return
        }
        this.noGet = true
        let data = {
          pageNumber: 1,
          length: 30,
          companyId: this.companyId
        }
        this.get('/DeviceAlarm/query', data).then(res => {
          if (res.success) {
            this.warnList = res.result.data
            let time = setTimeout(() => {
              this.noGet = false
              clearTimeout(time)
            }, 10000)

            // console.log(this.warnList)
          } else {
            this.$message({
              type: 'warning',
              message: `获取报警数据失败：${res.message}`
            })
          }
        })
      },
      // 订阅mqtt
      sendMqtt() {
        let clientId = this.$store.state.userData.code + '_' + this.companyCode + '_energy'
        let options = {
          clientId: clientId,
          connectTimeout: 600000,
          clean: true
        }
        this.mqttClient = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
        this.sendHold()
      },
      sendHold() {
        this.get('/Device/getList', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            let arr = res.result
            this.deviceList = arr
            let i = 1
            for (let item of arr) {
              let url = 'sys/device/' + item.code + '/status/push'
              this.mqttClient.subscribe(url, {
                qos: 1
              })
              this.subscribeArr.push(url)
              if (i == arr.length) {
                this.getHold()
              }
              i+=1
            }
            this.getMqttMessage()
          }
        })
      },
      getMqttMessage() {
        let t = this
        let url = `sys/company/${t.companyId}/status/push`
          this.mqttClient.subscribe(url, {
            qos: 1
        })
        t.mqttClient.on('message', (topic, message) => {
          // 数据集更新
          let item = JSON.parse(message.toString()); //转码
          // console.log(topic)
          if (topic.indexOf('sys/company') != -1) {
            t.getHold()
          }
          t.$forceUpdate()
        })
      },
      // 获取配置
      getConfig() {
        this.get('/EnergyConfig/getConfig', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            let obj = {}
            for (let item of res.result) {
              if (item.name == 'other') {
                item.value = JSON.parse(item.value)
              }
              obj[item.name] = item.value
            }
            this.config = obj
            this.$forceUpdate()
            if (obj.other) {
              this.initData()
              this.getDatasetData()
            }
            this.getLoad()
            this.sendMqtt()
            this.getWarn()
            this.getReport()
            this.getCost()
            this.getScore()
          } else {
            this.$message({
              type: 'warning',
              message: `获取配置失败：${res.message}`
            })
          }
        })
      },
      // 今日负荷 折线图
      setLineChart(value) {
        let self = this
        let newArry = value.sort(function(a, b) {
          return a.time - b.time;
        });
        let DataArr = []
        for (let item of newArry) {
          let arr = []
          if (item.time) {
            arr.push(this.changeTime(item.time))
            arr.push(item.value || "-")
          }
          DataArr.push(arr)
        }
        let name = "今日负荷"
        const data = {
          DataArr
        };
        let option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(1, 1, 14, .7)',
            borderWidth: "0",
            padding: 10,
            formatter: function(params) {
              if (!params[0].data) {
                return ''
              }
              let time = params[0].data[0],
                value = params[0].data[1]
              let html =
                `<span style="font-size:12px;color:#FFF;font-weight:400;">${time}</span><br>
                <span style="font-size:12px;color:#C4E1FF;font-weight:400;">负荷值：</span><span style="font-size:16px;color:#25AFEF;font-family: AgencyFB;font-weight:bold;">${value=='-'?'--':self.common.fmoney(value,0.1)+' kW·h'}</span>`;
              return html
            }
          },
          grid: {
            left: '70',
            right: '20',
            bottom: '60',
            top: '45'
          },
          yAxis: [{
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: 'rgba(155, 155, 155, 0.5)'
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#C4E1FF',
              fontSize: 11
            },

            splitNumber: 1,
            axisTick: {
              show: false
            },
            type: 'value'
          }],
          xAxis: [{
            type: 'time', // x轴为 时间轴
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 0
              }
            },
            axisLabel: {
              color: '#C4E1FF',
              fontSize: 11,
              formatter:function(value) {
                let h = new Date(value).getHours(),m =  new Date(value).getMinutes()
                if(h<10){ h = '0'+h }
                if(m<10){ m = '0'+m }
                return `${h}:${m}`
              }
            },
            axisTick: {
              show: false
            },
            boundaryGap: false,
            splitNumber: 11.5,
            data: data['DataArr'].map(function(item) {
              return item[0];
            })
          }],
          // legend: { data: titles },
          color: ['#25AFEF'],
          series: [{
            name: name,
            type: 'line',
            symbol: 'none',
            smooth: true,
            markPoint: {
              label: {
                normal: {
                  show: true,
                  backgroundColor: '#2c3e50',
                  position: 'top',
                  color: '#c4e1ff',
                  borderRadius: 2,
                  borderColor: '#2c3e50',
                  borderWidth: 1,
                  padding: 8,
                  formatter: function(data){
                    let value =self.common.fmoney(data.value,0.1)
                    return data.name + '：'+ value
                  }
                }
              },
              symbol: 'circle',
              itemStyle: {
                normal: {
                  borderColor: 'rgba(65,214,195,0.3)',
                  borderWidth: 15
                }
              },
              symbolSize: 7,
              data: [{
                  type: 'max',
                  name: '最大值'
                },
                {
                  type: 'min',
                  name: '最小值'
                }
              ]
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [{
                  offset: 0.25,
                  color: 'rgba(37,175,239,.5)' // 25% 处的颜色
                }, {
                  offset: 0.85,
                  color: 'rgba(15,39,56,.5)' // 50% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgba(15,39,56,.5)' // 50% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            lineStyle: {
              normal: {
                color: '#25AFEF',
                width: 1
              }
            },
            data: data['DataArr']
          }]
        };
        // debugger
        let dom = this.$refs.line
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("line"))
        if (Dom == null) {
          this.lineChart = this.$echarts.init(dom, '', {
            width: dom.offsetWidth - 20, //设置宽高
            height: dom.offsetHeight - 20, //设置宽高
          })
        }
        this.lineChart.setOption(option, true)
      },
      // 单位能耗
      getDatasetData() {
        let y = new Date().getFullYear()
        let m = new Date().getMonth()+1
        let d = new Date().getDate()
        let t = new Date(`${y}-${m}-${d} 0:0:0`).getTime()
        let data = {
          companyId: this.companyId,
          time:t
        }
        this.get('/EnergyElectricity/getHourReport', data).then(res => {
          if (res.success) {
            this.hosrArr = res.result
            for(let item of res.result){
              if(item.value){this.showBar = false}
            }
                this.$forceUpdate()
            let yesterday = new Date().setDate(d-1)
            y = new Date(yesterday).getFullYear()
            m = new Date(yesterday).getMonth()+1
            d = new Date(yesterday).getDate()
            t = new Date(`${y}-${m}-${d} 0:0:0`).getTime()
            data.time = t
            this.get('/EnergyElectricity/getHourReport', data).then(res => {
              if (res.success) {
                this.dayArr = res.result
                for(let item of res.result){
                  if(item.value){this.showBar = false}
                }
                this.$forceUpdate()
                this.setBarChart()
              } else {
                this.$message({
                  type: 'warning',
                  message: `获取小时单位能耗数据失败：${res.message}`
                })
              }
            })
          } else {
            this.$message({
              type: 'warning',
              message: `获取小时单位能耗数据失败：${res.message}`
            })
          }
        })
      },
      // 柱状图
      setBarChart() {
        if (!this.hosrArr[0] || !this.dayArr[0]) {
          return
        }
        let hosrArr = this.hosrArr.sort(function(a, b) {
          return a.time - b.time;
        });
        let dayArr = this.dayArr.sort(function(a, b) {
          return a.time - b.time;
        });
        let HosrArr = [],self=this
        for (let item of hosrArr) {
          let arr = []
          if (item.time) {
            arr.push(this.changeTime2(item.time))
            arr.push(item.value || "-")
          }
          HosrArr.push(arr)
        }
        let DayArr = []
        for (let item of dayArr) {
          let arr = []
          if (item.time) {
            arr.push(this.changeTime2(item.time))
            arr.push(item.value || "-")
          }
          DayArr.push(arr)
        }
        const data = {
          HosrArr,
          DayArr
        };
        // debugger
        let option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(1, 1, 14, .7)',
            borderWidth: "0",
            padding: 10,
            formatter: function(params) {
              if (!params[0].data) {
                return ''
              }
              let time = params[0].data[0],
                value1 = params[0].data[1],
                value2 = params[1].data[1]
              let html = `<span style="font-size:12px;color:#FFF;font-weight:400;">${time}</span><br>
                <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${params[0].seriesName}：</span><span style="font-size:16px;color:${params[0].color.colorStops[0].color};font-family: AgencyFB;font-weight:bold;">${value1=='-'?'--':self.common.fmoney(value1,0.1)+' kW·h'}</span><br>
                <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${params[1].seriesName}：</span><span style="font-size:16px;color:${params[1].color.colorStops[0].color};font-family: AgencyFB;font-weight:bold;">${value2=='-'?'--':self.common.fmoney(value2,0.1)+' kW·h'}</span>
                `;
              return html
            }
          },

          // legend: {
          //   data: ['小时单位能耗', '天时单位能耗']
          // },

          grid: {
            left: '40',
            right: '20',
            bottom: '60',
            top: '20'
          },
          yAxis: [{
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: 'rgba(155, 155, 155, 0.5)'
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#C4E1FF',
              fontSize: 11
            },

            splitNumber: 1.5,
            axisTick: {
              show: false
            },
            type: 'value'
          }],
          xAxis: [{
            type: 'category', // x轴为 类目轴
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 0
              }
            },
            axisLabel: {
              color: '#C4E1FF',
              fontSize: 11,
            },
            axisTick: {
              show: false
            },
            boundaryGap: false,
            splitNumber: 6,
            data: data['HosrArr'].map(function(item) {
              return item[0];
            })
          }],
          color: ['#00dbc4'],
          series: [{
              name: '今日',
              type: 'bar',
              data: data["HosrArr"],
              barWidth: 3,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00E1FB'
                  },
                  {
                    offset: 0.85,
                    color: '#037491'
                  },
                  {
                    offset: 1,
                    color: '#052445'
                  }
                ])
              }
            },
            {
              name: '昨日',
              type: 'bar',
              barCategoryGap: "5",
              // barGap: '150%',
              data: data["DayArr"],
              barWidth: 3,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#9999FF'
                  },
                  {
                    offset: 0.85,
                    color: '#31477C'
                  },
                  {
                    offset: 1,
                    color: '#052445'
                  }
                ])
              }
            }
          ]
        };

        let dom = this.$refs.bar
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("bar"))
        if (Dom == null) {
          this.barChart = this.$echarts.init(dom, '', {
            width: dom.offsetWidth - 20, //设置宽高
            height: dom.offsetHeight - 20, //设置宽高
          })
        }
        this.barChart.setOption(option, true)
      },
      changeTime2(time){
        let h = new Date(time).getHours()
        h<10? h='0'+h+'时' : h= h+'时'
        return h
      },
      // 获取配置数据
      initData() {
        let data = this.config.other
        let arr = []
        if(!data){ return }
        // 月用水定额
        if (data.water.length > 0) {
          if(data.water[0].substring(0,2)=='_V'){
            arr.push('water')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.water[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.water[1])[0]
                if (value) {
                  this.deviceValue.water = Number(value.value)
                }
              }
            })
          }
        }
        // 月用气定额
        if (data.gas.length > 0) {
          if(data.gas[0].substring(0,2)=='_V'){
            arr.push('gas')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.gas[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.gas[1])[0]
                if (value) {
                  this.deviceValue.gas = Number(value.value)
                }
              }
            })
          }
        }
        // 月用热定额
        if (data.thermal.length > 0) {
          if(data.thermal[0].substring(0,2)=='_V'){
            arr.push('thermal')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.thermal[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.thermal[1])[0]
                if (value) {
                  this.deviceValue.thermal = Number(value.value)
                }
              }
            })
          }
        }
        // 总用气量
        if (data.gasTotal.length > 0) {
          if(data.gasTotal[0].substring(0,2)=='_V'){
            arr.push('gasTotal')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.gasTotal[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.gasTotal[1])[0]
                if (value) {
                  this.deviceValue.gasTotal = Number(value.value)
                }
              }
            })
            let parmas={
              code:data.gasTotal[0]
            }
            this.get('/ProductFeature/getByDeviceCode',parmas).then(res=>{
              if(res.success){
                let arr = [];
                let tsl;
                if(res.result==''){
                    tsl={properties:[]}
                }else{
                    tsl = JSON.parse(res.result)
                }
                let obj = {code:data.gasTotal[0],attrlist:tsl.properties}
                tsl.properties.map((item)=>{
                  item.code = item.identifier
                })
                this.deviceAttrArr.push(obj)
                let a = tsl.properties.filter(i => i.identifier == data.gasTotal[1])[0]
                if(a){
                  this.deviceValue.gasTotalUnit = a.dataType.specs?a.dataType.specs.unit:''
                  this.deviceValue.gasTotalName = a.name
                }
              }else{
                this.$message({
                  type: 'warning',
                  message: `获取属性名称：${res.message}`
                })
                return '--'
              }
            })
          }
        }
        // 年用气量
        if (data.gasYear.length > 0) {
          if(data.gasYear[0].substring(0,2)=='_V'){
            arr.push('gasYear')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.gasYear[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.gasYear[1])[0]
                if (value) {
                  this.deviceValue.gasYear = Number(value.value)
                }
              }
            })
            let parmas={
              code:data.gasYear[0]
            }
            this.get('/ProductFeature/getByDeviceCode',parmas).then(res=>{
              if(res.success){
                let arr = [];
                let tsl;
                if(res.result==''){
                    tsl={properties:[]}
                }else{
                    tsl = JSON.parse(res.result)
                }
                let obj = {code:data.gasYear[0],attrlist:tsl.properties}
                tsl.properties.map((item)=>{
                  item.code = item.identifier
                })
                this.deviceAttrArr.push(obj)
                let a = tsl.properties.filter(i => i.identifier ==  data.gasYear[1])[0]
                if(a){
                  this.deviceValue.gasYearUnit = a.dataType.specs?a.dataType.specs.unit:''
                  this.deviceValue.gasYearName = a.name
                }
              }else{
                this.$message({
                  type: 'warning',
                  message: `获取属性名称：${res.message}`
                })
                return '--'
              }
            })
          }
        }
        // 月用气量
        if (data.gasMonth.length > 0) {
          if(data.gasMonth[0].substring(0,2)=='_V'){
            arr.push('gasMonth')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.gasMonth[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.gasMonth[1])[0]
                if (value) {
                  this.deviceValue.gasMonth = Number(value.value)
                }
              }
            })
            let parmas={
              code:data.gasMonth[0]
            }
            this.get('/ProductFeature/getByDeviceCode',parmas).then(res=>{
              if(res.success){
                let arr = [];
                let tsl;
                if(res.result==''){
                    tsl={properties:[]}
                }else{
                    tsl = JSON.parse(res.result)
                }
                let obj = {code:data.gasMonth[0],attrlist:tsl.properties}
                tsl.properties.map((item)=>{
                  item.code = item.identifier
                })
                this.deviceAttrArr.push(obj)
                let a = tsl.properties.filter(i => i.identifier ==  data.gasMonth[1])[0]
                if(a){
                  this.deviceValue.gasMonthUnit = a.dataType.specs?a.dataType.specs.unit:''
                  this.deviceValue.gasMonthName = a.name
                }
              }else{
                this.$message({
                  type: 'warning',
                  message: `获取属性名称：${res.message}`
                })
                return '--'
              }
            })
          }
        }
        // 日用气量
        if (data.gasDay.length > 0) {
          if(data.gasDay[0].substring(0,2)=='_V'){
            arr.push('gasDay')
          } else {
            let v = {
              companyId: this.companyId,
              deviceCode: data.gasDay[0]
            }
            this.get('/Device/getPropertyValue', v).then(res => {
              if (res.success) {
                let value = res.result.filter(item => item.code == data.gasDay[1])[0]
                if (value) {
                  this.deviceValue.gasDay = Number(value.value)
                }
              }
            })
            let parmas={
              code:data.gasDay[0]
            }
            this.get('/ProductFeature/getByDeviceCode',parmas).then(res=>{
              if(res.success){
                let arr = [];
                let tsl;
                if(res.result==''){
                    tsl={properties:[]}
                }else{
                    tsl = JSON.parse(res.result)
                }
                let obj = {code:data.gasDay[0],attrlist:tsl.properties}
                tsl.properties.map((item)=>{
                  item.code = item.identifier
                })
                this.deviceAttrArr.push(obj)
                let a = tsl.properties.filter(i => i.identifier == data.gasDay[1])[0]
                if(a){
                  this.deviceValue.gasDayUnit= a.dataType.specs?a.dataType.specs.unit:''
                  this.deviceValue.gasDayName= a.name
                }
              }else{
                this.$message({
                  type: 'warning',
                  message: `获取属性名称：${res.message}`
                })
                return '--'
              }
            })
          }
        }
        if(arr.length){
          if(this.VirtualDevice.id){
            this.getVirtualDeviceAttrName(arr,data)
          }else{
            this.get('/VirtualDevice/get',{companyId:this.companyId}).then(res=>{
              if(res.success){
                this.VirtualDevice = res.result
                this.getVirtualDeviceAttrName(arr,data)
              }else{
                this.$message({
                  type: 'warning',
                  message: `获取虚拟设备失败：${res.message}`
                })
              }
            })
          }
        }
        this.$forceUpdate()
        // console.log(this.deviceValue)
      },
      getVirtualDeviceAttrName(arr,data){
        if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
        let v = {
          companyId:this.companyId,
          deviceId:this.VirtualDevice.id
        }
        this.get('/VirtualDevice/getPropertyValue',v).then(res=>{
          if (res.success) {
            this.VirtualDeviceValue = res.result
            for(let key of arr){
              let value = res.result.filter(item => item.code == data[key][1])[0]
              if (value) {
                this.deviceValue[key] = Number(value.value)
              }
            }
          }
        })
        this.get('/VirtualDevice/getPropertyList',v).then((res)=>{
          if(res.success){
            for(let key of arr){
              let a = res.result.filter(item => item.code == data[key][1])[0]
              if (a) {
                this.deviceValue[key+'Unit'] = a.unit?a.unit:''
                this.deviceValue[key+'Name'] = a.name
              }
            }
          }else{
            this.$message({
              type: 'warning',
              message: `获取虚拟设备属性名称失败：${res.message}`
            })
          }
        })
      },
      // 获取电能统计数据
      getReport() {
        this.get('/EnergyElectricity/getReport', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.Report = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取电能统计数据失败：${res.message}`
            })
          }
        })
      },
      // 获取电能成本数据
      getCost() {
        this.get('/EnergyElectricity/getCost', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.Cost = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取电能成本数据失败：${res.message}`
            })
          }
        })
      },
      //  获取电能评分数据
      getScore() {
        this.get('/EnergyElectricity/getScore', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.Score = res.result
            this.setRadar()
          } else {
            this.$message({
              type: 'warning',
              message: ` 获取电能评分数据失败：${res.message}`
            })
          }
        })
      },
      // 获取今日负荷数据
      getLoad() {
        this.get('/EnergyElectricity/getLoad', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.Load = res.result
            this.setLineChart(this.Load)
          } else {
            this.$message({
              type: 'warning',
              message: `获取今日负荷数据失败：${res.message}`
            })
          }
        })
      },
      resizeChart(){
        if(this.barChart){
          let dom = this.$refs.bar
          this.barChart.resize( )
        }
        if(this.lineChart){
          let dom = this.$refs.bar
          this.lineChart.resize()
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      // from.meta.isBack = true;
      if(this.mqttClient){
        for (let url of this.subscribeArr) {
          this.mqttClient.unsubscribe(url, () => {})
        }
        // debugger
        this.mqttClient.end()
      }
      next();
    },
  }
</script>

<style scoped>
  .today{
    font-size: 12px;
    color: #C4E1FF;
    text-align: right;
    position: absolute;
    right: 20px;
    top: 45px;
  }
  .today>span{
    margin-right: 10px;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #01A6AC;
    margin-right: 10px;
    box-sizing: border-box;
  }
  .legend{
    text-align: right;
    margin-top: 5px;
    color: #C4E1FF;
  }
  .legend span{
    margin-right: 20px;
  }
  .hosr>span{
    margin-right: 10px;
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #00FFF6;
  }
  .day>span{
    display: inline-block;
    margin-right: 10px;
    width: 8px;
    height: 8px;
    background: #9999FF;
  }
  .bottom-title {
    display: flex;
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 24px;
  }

  .bottom-title span {
    display: inline-block;
    width: 20%;
    font-size: 12px;
    font-weight: 400;
    color: #C4E1FF;
  }

  #radar {
    width: 335px;
    height: 188px;
    margin: 42px auto 0;
  }

  .bg-box {
    width: 100%;
    height: 100%;
    background: url(../../assets/image/energy/bg8.png) no-repeat;
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  .ratio {
    font-size: 14px;
    font-weight: 400;
    color: #5087E4;
    line-height: 14px;
    padding-left: 5px;
  }

  .ratio img {
    width: 10px;
    height: 14px;
    margin: 0 3px;
  }

  .ratio>span {
    font-size: 14px !important;
  }
  #bar{
    height: 78%;
  }
  #line{
    height: 90%;
  }
  .bottom {
    height: 28%;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: left;
  }

  .warn-box {
    height: 188px;
    overflow-y: auto;
  }

  .w-30 {
    width: 30%;
  }

  .w-20 {
    width: 20%;
  }

  .warn-title li,
  .warn-lab li {
    font-size: 14px;
    font-weight: 400;
    color: #CCFFFF;
    display: inline-block;
    line-height: 28px;
    padding-right: 5px;
    box-sizing: border-box;
  }

  .warn-lab li {
    font-size: 12px;
    font-weight: 400;
    color: #96A8B7;
    line-height: 38px;
  }

  .warn-lab:nth-child(2n) {
    background: rgba(0, 102, 255, 0.1);
    box-shadow: 0px -1px 0px 0px rgba(0, 58, 162, 0.4);
  }

  .warn-title,
  .warn-lab {
    width: 100%;
    height: 28px;
    text-align: left;
    font-size: 0;
    padding-left: 10px;
    box-sizing: border-box;
  }

  .warn-lab {
    height: 38px;
    margin: 0 auto;
  }

  .warn-title {
    margin: 15px auto 0;
    background: url(../../assets/image/energy/bg7.png) no-repeat;
    background-size: 100%;
  }

  .img-box3 img {
    width: 48px;
    height: 46px;
    margin: 43px 15px 0 30px;
  }

  .lab-box {
    width: calc(100% - 93px);
    margin-top: 40px;
  }

  .lab-box>div {
    font-size: 16px;
    line-height: 17px;
    font-weight: 400;
    color: #CCFFFF;
  }
  .lab-box .num-unit{
    color: #2BA8FF;
    background: linear-gradient(0deg, #8C8DEB 0%, #5087E4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .notData{
    position: absolute;
    top: 50%;
    width: 100%;
    text-align: center;
    color: #fff;
  }
  .lab-value {
    font-size: 26px;
    line-height: 40px;
    padding-right: 5px;
    font-family: AgencyFB;
    font-weight: bold;
    font-style: italic;
    color: #2BA8FF;
    background: linear-gradient(0deg, #8C8DEB 0%, #5087E4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .lab-unit {
    font-size: 14px;
    font-weight: bold;
    color: #2BA8FF;
  }

  .item-box {
    width: 233px;
    height: 110px;
    background: url(../../assets/image/energy/bg6.png) no-repeat;
    background-size: cover;
    position: absolute;
  }

  .m-t-10 {
    margin-top: 7px;
  }


  .blue2 {
    font-size: 18px;
    font-family: AgencyFB;
    font-weight: bold;
    font-style: italic;
    color: #25AFEF;
  }

  .yellow {
    font-size: 18px;
    font-family: AgencyFB;
    font-weight: bold;
    font-style: italic;
    color: #DD6E24;
  }

  .blue {
    font-size: 14px;
    font-weight: 400;
    color: #5087E4;
  }


  .unit2 {
    font-size: 12px;
    font-weight: 400;
    color: #25AFEF;
  }

  .unit {
    font-size: 12px;
    font-weight: 400;
    color: #DD6E24;
  }
  .exceed {
    font-size: 14px;
    font-weight: 400;
    color: #96A8B7;
  }

  .data-title {
    font-size: 14px;
    color: #CCFFFF;
  }

  .data-title span {
    font-size: 14px;
    font-weight: 400;
    color: #5087E4;
  }

  .img-box2 img {
    width: 29px;
    height: 33px;
    margin: 0 6px 0 14px;
  }

  .right-data {
    width: calc(100% - 50px);

  }
  .attr .details-title{
    padding: 0 18px ;
    box-sizing: border-box;
  }
  .details-title {
    width: 100px;
    font-size: 16px;
    font-weight: bold;
    color: #CCFFFF;
    text-align: center;
    line-height: 31px;
    height: 31px;
    background: url(../../assets/image/energy/bg5.png) no-repeat;
    background-size: cover;
  }

  .details {
    width: 63%;
    margin: 10px 5px;
    font-size: 20px;
    font-family: AgencyFB;
    font-weight: bold;
    color: #25AFEF;
  }

  .details>p {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .details span {
    font-size: 12px;
    font-weight: 400;
  }

  .img-box img {
    width: 32px;
    height: 36px;
    margin: 20px 0 15px 20px;
  }

  .m-l-0 img {
    margin-left: 5px;
  }

  .data-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .data-box>div {
    width: 50%;
  }

  .title img {
    widows: 22px;
    height: 22px;
    position: relative;
    top: 4px;
    margin-right: 3px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 42px;
  }

  .box1 {
    height: 41%;
    width: 100%;
    background: url(../../assets/image/energy/bg3.png) no-repeat;
    background-size: cover;
    position: relative;
  }

  .box2 {
    height: 54%;
    width: 100%;
    background: url(../../assets/image/energy/bg4.png) no-repeat;
    background-size: cover;
    margin-top: 10px;
  }
  .bottom .box1,.bottom .box2{
    height: 100%;
  }
  .bg2{
    background: url(../../assets/image/energy/bg2.png) no-repeat;
    background-size: 100% 100%;
  }
  .box3 {
    height: 546px;
    width: 920px;
    background: url(../../assets/image/energy/q.png) no-repeat;
    position: relative;
    background-position: center;
    margin: 0 auto;
  }

  .score {
    position: absolute;
    font-size: 88px;
    font-family: AgencyFB;
    font-weight: bold;
    font-style: italic;
    color: #4BDFFB;
    top: 50%;
    width: 100%;
    left: 0;
    text-align: center;
    margin-top: -64px;
  }

  .score span {
    font-size: 20px;
  }

  .w-910 {
    width: 55.5%;
    height: 100%;
  }

  .w-335 {
    width: calc((45% - 60px) / 2);
    height: 100%;
  }

  .m-l-20 {
    margin-left: 20px;
  }

  .centent {
    height: 62%;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: left;
  }

  .nobg {
    background: url(../../assets/image/energy/bg9.png) no-repeat;
    background-size: cover;
  }

  #EnergyIndex {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(../../assets/image/energy/bg.png) no-repeat;
    background-size: cover;
    min-width: 1660px;
    min-height: 857px;
  }

  .top {
    height: 67px;
    line-height: 67px;
    width: 1306px;
    margin: 0 auto;
    background: url(../../assets/image/energy/bg1.png) no-repeat;
    background-size: cover;
    font-size: 24px;
    font-weight: bold;
    color: #3399FF;
  }
  .num-unit{
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    position: relative;
    top: -2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Energy/index.vue